/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import Header, { HeaderProps } from "@/src/components/Header/Header";
import React from "react";
import HeaderActions from "@/src/components/HeaderActions/HeaderActions";

export type LayoutHeaderDefaultProps = {
  clickableLogo?: boolean;
  minimal?: boolean;
};

export const LayoutHeaderDefault = ({ clickableLogo, minimal }: LayoutHeaderDefaultProps) => {
  const headerProps: HeaderProps = {
    logoLink: clickableLogo
      ? {
          label: "Zur Startseite",
          to: "/",
        }
      : null,
    navItems: !minimal
      ? [
          {
            type: "category",
            label: "Rechtsbereiche",
            items: [
              {
                type: "link",
                to: "/vertragsrecht",
                label: "Vertragrecht",
              },
              {
                type: "link",
                to: "/mietrecht",
                label: "Mietrecht",
              },
              {
                type: "link",
                to: "/verkehrsrecht",
                label: "Verkehrsrecht",
              },
              {
                type: "link",
                to: "/familienrecht",
                label: "Familienrecht",
              },
              {
                type: "link",
                to: "/arbeitsrecht",
                label: "Arbeitsrecht",
              },
              {
                type: "link",
                to: "/allgemeines-zivilrecht",
                label: "Allgemeines Zivilrecht",
              },
            ],
          },
          {
            type: "link",
            label: "Über uns",
            to: "/ueber-uns",
          },
          {
            type: "link",
            label: "Kontakt",
            to: "/kontakt",
          },
          {
            type: "link",
            label: "Jobs",
            to: "/jobs",
          },
          {
            type: "link",
            label: "Partneranwalt werden",
            to: "/lp/partneranwalt-werden",
          },
        ]
      : null,
    actions: !minimal && <HeaderActions />,
  };

  return <Header {...headerProps} />;
};
